export function bytesConverter(bytes: number, precision: number = 0) {
    if (bytes === undefined || bytes === null || isNaN(bytes) || bytes < 0) {
        return "0 B";
    }
    if (bytes < 1024) {
        return bytes + ' B';
    } else if (bytes < Math.pow(1024, 2)) {
        return (bytes / 1024).toFixed(precision) + ' KB';
    } else if (bytes < Math.pow(1024, 3)) {
        return (bytes / Math.pow(1024, 2)).toFixed(precision) + ' MB';
    } else if (bytes < Math.pow(1024, 4)) {
        return (bytes / Math.pow(1024, 3)).toFixed(precision) + ' GB';
    } else if (bytes < Math.pow(1024, 5)) {
        return (bytes / Math.pow(1024, 4)).toFixed(precision) + ' TB';
    }
}